























































































import { Component, Mixins, Prop } from 'vue-property-decorator'

import { mdiLogout, mdiPhoneOutline, mdiChevronDown, mdiEye } from '@mdi/js'

import { security } from '@/store/modules/security'
import { settings } from '@/store/modules/settings'
import { notifications } from '@/store/modules/notifications'
import { Navigator } from '@/mixins/Navigator'
import PortalNavigationMenu from '@/components/layouts/PortalNavigationMenu.vue'
import { Themes } from '@/themes'

@Component({
  components: {
    PortalNavigationMenu,
  },
})
class WithCardsHeader extends Mixins<Navigator>(Navigator) {
  Themes = Themes

  @Prop({
    type: String,
    default: '',
  })
  readonly phone: string

  @Prop({
    type: String,
    default: '',
  })
  readonly portalLink: string

  securityModule = security.context(this.$store)
  settingsModule = settings.context(this.$store)
  notificationsModule = notifications.context(this.$store)
  icons = {
    mdiLogout,
    mdiChevronDown,
    mdiPhoneOutline,
    mdiEye,
  }
  htmlTag = document.documentElement

  navigationDrawerModel = false

  get theme() {
    return this.$theme.name
  }

  set theme(theme: Themes) {
    this.$setTheme(theme)
  }

  get notificationIconColor() {
    return this.$route.name === 'notifications' ? 'accent' : 'base'
  }
}

export default WithCardsHeader
